<div class="twofactorDialog">
  <sync-dialog 
    [config]="
    {
      title: newBackupCodes ? 'Generate new backup codes' : 'Two-factor authentication (2FA)', 
      isClosable: true,
      closeIcon: (showTwofaEmailPrompt || showQRCode || showVerificationPrompt || (newBackupCodes && !backupCodes)) ? 'arrow-left' : 'close',
      onCloseIcon: onBack,
      actionButton: (showTwofaEmailPrompt || showVerificationPrompt) ? 'Enable 2FA' : showQRCode ? 'Continue' : (newBackupCodes && !backupCodes) ? 'Generate' : '', 
      cancelButton: (showTwofaEmailPrompt || showQRCode || showVerificationPrompt || (newBackupCodes && !backupCodes)) && 'Cancel',
      onActionClick: showTwofaEmailPrompt ? update2FA : showQRCode ? verifyCode : newBackupCodes ? generateBackupCodes : updateGoogleAuth,
      onCancelClick: closeTwoFactorDialog,
      isButtonLoading: isEnableButtonLoading,
      iconDisabled: backButtonDisabled,
      isActionButtonDisabled: newBackupCodes && !password 
    }" 
    [open]="showTwoFactorDialog" 
    [isFullScreen]="false" 
    [onClose]="closeTwoFactorDialog"
    [hideDialogFooter]="showBackupCodeDialog || twofaType === TWOFATYPE_NONE">
    <!-- if disabled -->
    <div class="twofa-options" *ngIf="twofaType === TWOFATYPE_NONE">
      <sync-list [ListItems]="twoFactorTypes"></sync-list>
    </div>

    <app-error class="error-msg" *ngIf="errcode" [errcode]="errcode" [showErrCode]="showErrCode"></app-error>

    <div class="twofaEmailPrompt" *ngIf="showTwofaEmailPrompt">
      <sync-alert [type]="'warning'" [showLeadIcon]="true" [leadIcon]="'warning'" [title]="'2FA via email is disabled'"
        [description]="''" [showActions]="false" [showPrimaryAction]="false" 
        [showSecondaryAction]="false" [showCloseButton]="false"></sync-alert>
      <div class="twofa-content">
        <span class="h6 color-onsurface">Secure your account with two-factor authentication via email.</span>
        <span class="body-2">Prevent unauthorized access to your files and folders on Sync. During web login you will be
          prompted for a 2FA code, which will be sent to the email address linked to your Sync account.</span>
      </div>
    </div>

    <div *ngIf="showQRCode">
      <div class="google-auth">
        <span class="h6 color-onsurface">Scan the QR code using your authentication app</span>
        <span class="body-1">You can also manually enter the setup key below the image.</span>
        <qrcode [qrdata]="qrdata" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
        <span class="subtitle-1 color-onsurface">{{ twofakey }}</span>
      </div>
    </div>

    <div class="verification-block" *ngIf="showVerificationPrompt">
      <div class="google-auth">
        <span class="h6 color-onsurface">Enter the 6-digit verification code provided by your authentication app</span>
        <div class="otp-input">
          <sync-otp-input 
            #otpInputComponent 
            [length]="6" 
            [disabled]="otpDisabled" 
            [getOtpValue]="getOtpValue" 
            [errorMessage]="incorrectOTPError">
          </sync-otp-input>
        </div>
      </div>
    </div>

    <ng-container *ngIf="(twofaType === TWOFATYPE_GOOGLE || twofaType === TWOFATYPE_EMAIL)">
      <sync-alert 
        *ngIf="!newBackupCodes"
        [type]="'promo'" 
        [showLeadIcon]="true" 
        [leadIcon]="'success'" 
        [title]="'2FA has been enabled'"
        [description]="twofaType === TWOFATYPE_EMAIL ? 'Authentication emails will be sent to: ' + user.email : 'Authentication codes will be generated by your chosen authenticator application.'" 
        [showActions]="true"
        [primaryButtonConfig]="{label: 'Disable 2FA', type: 'outlined', onClick: disable2FA}"
        [showSecondaryAction]="false" 
        [showCloseButton]="false"
        ></sync-alert>

        <div class="backupcode-block" *ngIf="!newBackupCodes && !showBackupCodeDialog">
          <sync-button [type]="'flat'" [label]="'Generate new backup codes'" [onClick]="generateNewBackupCodes"></sync-button>
        </div>

        <div class="new-backup-codes" *ngIf="(newBackupCodes && !backupCodes)">
          <div class="body-2">
            When you generate new backup codes, your old codes will be deleted and no longer work. You must download or save the new codes.
         </div>
         <sync-text-field [inputType]="'password'" [label]="'Password'" [value]="password" [inputChange]="getPassword" [errorMessage]="incorrectPassError"></sync-text-field>
        </div>
    </ng-container>

    <div *ngIf="showBackupCodeDialog">
      <div class="backupcode-content">
        <span class="body-bold-1 color-onsurface">Please copy the backup codes below and keep them in a safe place.</span>
        <span class="body-2">These backup codes will help you recover your Sync account if you cannot access the linked
          email address.</span>
        <div class="backup-codes body-1">
          <ul class="code-list">
            <li *ngFor="let code of backupCodes.slice(0, 5)">{{ code }}</li>
          </ul>
          <ul class="code-list">
            <li *ngFor="let code of backupCodes.slice(5)">{{ code }}</li>
          </ul>
        </div>
      </div>
      <div class="code-actions">
        <sync-button [type]="'flat'" [label]="'Download codes'" [onClick]="downloadBackupCodes"></sync-button>
        <sync-button [type]="'flat'" [label]="'Copy codes to clipboard'" [onClick]="copyCodesToClipboard"></sync-button>
      </div>
    </div>
  </sync-dialog>
</div>